import React, { useState } from "react";
import { useApp } from "../../context/AppContext";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";

export default function AdminLogin() {
    const { login } = useApp();
    const navigate = useNavigate();
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [submitting, setSubmitting] = useState(false);

    const onSubmit = async (e) => {
        e.preventDefault();
        setSubmitting(true);
        try {
            const u = await login(email, password);
            if (u.role !== "admin") {
                toast.error("Questo account non è un amministratore");
                setSubmitting(false);
                return;
            }
            toast.success(`Bentornato, ${u.name}`);
            navigate("/admin");
        } catch (err) {
            toast.error(err.response?.data?.detail || "Accesso non riuscito");
            setSubmitting(false);
        }
    };

    return (
        <div className="min-h-screen bg-[color:var(--ms-ivory)] flex items-center justify-center px-6" data-testid="admin-login-page">
            <div className="max-w-md w-full panel p-10">
                <div className="overline mb-3">Area riservata</div>
                <h1 className="font-display text-4xl text-[color:var(--ms-charcoal)] mb-2">Portale Admin</h1>
                <p className="text-[color:var(--ms-muted)] text-sm mb-8">Accesso sicuro. Solo personale autorizzato.</p>
                <form onSubmit={onSubmit} className="space-y-5">
                    <div>
                        <label className="overline block mb-2">Email</label>
                        <input type="email" required value={email} onChange={e => setEmail(e.target.value)} className="w-full bg-[color:var(--ms-warm-white)] border border-[color:var(--ms-border)] focus:border-[color:var(--ms-charcoal)] px-3 py-3 text-sm outline-none text-[color:var(--ms-charcoal)]" data-testid="admin-login-email" />
                    </div>
                    <div>
                        <label className="overline block mb-2">Password</label>
                        <input type="password" required value={password} onChange={e => setPassword(e.target.value)} className="w-full bg-[color:var(--ms-warm-white)] border border-[color:var(--ms-border)] focus:border-[color:var(--ms-charcoal)] px-3 py-3 text-sm outline-none text-[color:var(--ms-charcoal)]" data-testid="admin-login-password" />
                    </div>
                    <button type="submit" disabled={submitting} className="w-full bg-[color:var(--ms-charcoal)] text-[color:var(--ms-warm-white)] py-4 text-xs tracking-[0.22em] font-medium hover:bg-[color:var(--ms-sage-dark)] transition-colors disabled:opacity-50" data-testid="admin-login-submit">
                        {submitting ? "ACCESSO…" : "ACCEDI"}
                    </button>
                </form>
            </div>
        </div>
    );
}
